define('app/models/customer',['app/setup'], function(takhfifan) {
  takhfifan.Customer = Backbone.Model.extend({

    validation: {
      firstname: {
          required: true,
          msg: i18n.t('first_name_missing')
      },
      lastname: {
          required: true,
          msg: i18n.t('last_name_missing')
      },
      gender: {
        required: true,
        msg: i18n.t('gender_missing')
      },
      'email': function (value, key, fields) {
        var emailRequired = fields['email_required'] === 'true';
        if (emailRequired && !value) {
          return i18n.t('email_missing');
        }
        if (value && !(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value))) {
          return i18n.t('email_invalid');
        }
      },
      city: {
        required: true,
        msg: i18n.t('city_missing')
      }
    },

    save: function(url) {
      var _this = this;
      var json = this.toJSON();

      $.post(url, json).done(function(data){
        if (!_.isNull(data)) {
          if (typeof data == 'string') {
            data = JSON.parse(data);
          }
          if (!_.isNull(data.error) && data.error == 1) {
            takhfifan.eventHub.trigger('customer_profile:error', [data.message]);
          }
          else {
            takhfifan.eventHub.trigger('customer_profile:saved', data.customer_profile);
          }
          if(!_.isNull(data.form_key))
          {
            takhfifan.eventHub.trigger('formkey', data.form_key);
          }
        }
      }).fail(function(data){
        takhfifan.eventHub.trigger(
          'customer_profile:error',
          [data.responseJSON.msg]
        );
      });
    }
  });
});

